import {
    SEARCH_PLANT,
    TOGGLE_SEARCH_PLANT,
    RESET_SEARCH_PLANT,
    CHANGE_SEARCH_QUERY,
    TOGGLE_FILTER_PLANT,
    LOADING_PLANT_SEARCH
} from '../actions'

const INITIAL_STATE = {
    isLoading: false,
    filters: {},
    active: false,
    plants: [],
    isLast: false,
    query: '',
    page: 1,
}

function PlantListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SEARCH_PLANT:
            return {
                ...state,
                plants: action.meta.searchQuery !== state.query
                    ? action.payload.body.plants
                    : [...state.plants, ...action.payload.body.plants],
                isLast: action.payload.body.last,
                isLoading: false,
                page: state.page + 1,
            }
        case CHANGE_SEARCH_QUERY:
            return {
                ...state,
                query: action.payload,
                isLoading: true,
                plants: [],
                page: 1,
            }
        case RESET_SEARCH_PLANT:
            return {
                ...INITIAL_STATE,
                filters: state.filters,
            }
        case TOGGLE_SEARCH_PLANT:
            return {
                ...state,
                active: action.payload,
            }
        case TOGGLE_FILTER_PLANT:
            return {
                ...state,
                filters: {
                    [action.payload.name]: action.payload.active,
                },
            }
        case LOADING_PLANT_SEARCH:
            return {
                ...state,
                isLoading: true,
            }
        default: return state
    }
}

export default PlantListReducer



// WEBPACK FOOTER //
// ./src/reducers/search.js